export const Toast = () => import('../../components/Toast.vue' /* webpackChunkName: "components/toast" */).then(c => wrapFunctional(c.default || c))
export const DiffActionBar = () => import('../../components/diffActionBar.vue' /* webpackChunkName: "components/diff-action-bar" */).then(c => wrapFunctional(c.default || c))
export const Footer = () => import('../../components/footer.vue' /* webpackChunkName: "components/footer" */).then(c => wrapFunctional(c.default || c))
export const InlineDiff = () => import('../../components/inlineDiff.vue' /* webpackChunkName: "components/inline-diff" */).then(c => wrapFunctional(c.default || c))
export const Navbar = () => import('../../components/navbar.vue' /* webpackChunkName: "components/navbar" */).then(c => wrapFunctional(c.default || c))
export const SingleDiff = () => import('../../components/singleDiff.vue' /* webpackChunkName: "components/single-diff" */).then(c => wrapFunctional(c.default || c))
export const ButtonsCopyLink = () => import('../../components/buttons/copyLink.vue' /* webpackChunkName: "components/buttons-copy-link" */).then(c => wrapFunctional(c.default || c))
export const ButtonsNextDiff = () => import('../../components/buttons/nextDiff.vue' /* webpackChunkName: "components/buttons-next-diff" */).then(c => wrapFunctional(c.default || c))
export const ButtonsPrevDiff = () => import('../../components/buttons/prevDiff.vue' /* webpackChunkName: "components/buttons-prev-diff" */).then(c => wrapFunctional(c.default || c))
export const ButtonsSkipToNav = () => import('../../components/buttons/skipToNav.vue' /* webpackChunkName: "components/buttons-skip-to-nav" */).then(c => wrapFunctional(c.default || c))
export const ButtonsStickyCopy = () => import('../../components/buttons/stickyCopy.vue' /* webpackChunkName: "components/buttons-sticky-copy" */).then(c => wrapFunctional(c.default || c))
export const ButtonsToggleInSync = () => import('../../components/buttons/toggleInSync.vue' /* webpackChunkName: "components/buttons-toggle-in-sync" */).then(c => wrapFunctional(c.default || c))
export const ButtonsToggleInlineDiffView = () => import('../../components/buttons/toggleInlineDiffView.vue' /* webpackChunkName: "components/buttons-toggle-inline-diff-view" */).then(c => wrapFunctional(c.default || c))

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
